import { render, staticRenderFns } from "./cari2.vue?vue&type=template&id=2b19d2ed&scoped=true&"
import script from "./cari2.vue?vue&type=script&lang=js&"
export * from "./cari2.vue?vue&type=script&lang=js&"
import style0 from "./cari2.vue?vue&type=style&index=0&id=2b19d2ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b19d2ed",
  null
  
)

export default component.exports